document.addEventListener('DOMContentLoaded', () => {
  // Desktop only
  if ('ontouchstart' in window) return;

  document.querySelectorAll('.carousel__drag').forEach(track => {
    let isDown = false;
    let startX;
    let scrollLeft;

    track.addEventListener('mousedown', (e) => {
      isDown = true;
      track.classList.add('is-dragging');
      console.log(track.offsetLeft);
      startX = e.pageX - track.offsetLeft;
      scrollLeft = track.scrollLeft;

    });

    document.addEventListener('mouseup', () => {
      isDown = false;
      track.classList.remove('is-dragging');

    });

    document.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - track.offsetLeft;
      const walk = (x - startX);
      track.scrollLeft = scrollLeft - walk;
    });
  });
});
